module.exports = {"id":"dp2_4l3q5","text":"Collaborating through Digital Technologies","instructions":"AI features in collaboration tools may have limitations that users should be aware of.","multiselect":false,"questionType":"PickOne","random":false,"options":[{"id":"dp2_4l3q5-a1","text":"True","score":3.7},{"id":"dp2_4l3q5-a2","text":"Not sure","score":1.3},{"id":"dp2_4l3q5-a3","text":"False","score":1.3}],"groupTitle":"Digital Profiler Knowledge Matrix","category":"2.4"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.4/l3q5.json
// module id = 1054
// module chunks = 41